import { AccordionTab } from 'primereact/accordion';
import React, { ReactNode } from 'react';
import {
  AccordionHeaderType,
  AccordionTabHeaderTemplate,
  LiliAccordion,
} from '../../../DesignSystem/LiliAccordion/LiliAccordion';
import Heading from '../../../generic-components/Heading';

interface IAdditionalFields {
  additionalFieldsList: {title: string, body: ReactNode}[];
}

export const AdditionalFields = ({ additionalFieldsList }: IAdditionalFields) => (
  <LiliAccordion type={AccordionHeaderType.BORDER_BOTTOM} multiple>
    {additionalFieldsList.map((field) =>
      (
        <AccordionTab
          headerTemplate={() => (
            <AccordionTabHeaderTemplate
              Header={() => <Heading title={field.title} className='font-metricR text-surface-primary-bw-07' />}
            />
          )}
        >
          {field.body}
        </AccordionTab>
      ))}
  </LiliAccordion>
);
